import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M9.5 16q-2.725 0-4.612-1.887T3 9.5t1.888-4.612Q6.775 3 9.5 3t4.613 1.888Q15.999 6.775 16 9.5a6.1 6.1 0 0 1-1.3 3.8l5.6 5.6a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-5.6-5.6A6.1 6.1 0 0 1 9.5 16m0-2q1.875 0 3.188-1.313Q14 11.375 14 9.5t-1.313-3.188Q11.375 5 9.5 5T6.312 6.313C4.999 7.626 5 8.25 5 9.5q0 1.875 1.313 3.188Q7.625 14 9.5 14" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }